// react
import styled from 'styled-components';

// theme
import { theme } from '@/theme';

/**
 * CardColor renders a card with a color.
 */
export const CardColor = ({
  className,
  children,
  color = 'blue',
  isBordered = true,
}: CardColorProps) => {
  return (
    <Wrapper
      className={className}
      $isBordered={isBordered}
      $color={typeof color === 'string' ? color : 'blue'}
    >
      {children}
    </Wrapper>
  );
};

interface WrapperProps {
  $color: keyof typeof theme.color.cards;
  $isBordered: boolean;
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${(props) => props.theme.spacing[32]};
  align-items: flex-start;
  background: ${(props) => props.theme.color.cards[props.$color].primary};
  border: ${(props) =>
    props.$isBordered
      ? `1px solid ${props.theme.color.cards[props.$color].secondary}`
      : 'none'};
  color: ${(props) => props.theme.color.neutral[80]};
  border-radius: 8px;
  padding: ${(props) => props.theme.spacing[32]};
`;

interface CardColorProps {
  className?: string;
  children?: React.ReactNode;
  color?: keyof typeof theme.color.cards;
  isBordered?: boolean;
}

CardColor.displayName = 'CardColor';

export default CardColor;
